import * as Styled from './_styled/logo-container.styled'
import {LogoGroup} from '../../../../pages/login-v2/components/header/LogoGroup'
import {DEFAULT_REDIRECT_URL} from '@/values/default-redirect-url'

import type {JSX} from 'react'

export function LogoContainer(): JSX.Element {
    return (
        <Styled.LeftContainerStyle>
            <Styled.LogoStyle
                id="navigation-logo"
                to={DEFAULT_REDIRECT_URL}
                aria-label="Medulla dashboard"
            >
                <LogoGroup />
            </Styled.LogoStyle>
        </Styled.LeftContainerStyle>
    )
}
